<template>
  <div
    :class="['ioc-table', page.total ? 'ioc-pagination' : '']"
    id="ioc-table"
  >
    <!-- 可配置搜索条件 -->
    <div class="ioc-table__search" v-if="searchLength">
      <!-- <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div>筛选条件</div>
        <div>
          <el-button
            type="text"
            size="medium"
            style="color: #407aee"
            @click="showSearch = !showSearch"
            :icon="showSearch ? 'el-icon-arrow-up ' : 'el-icon-arrow-down'"
            >{{ !showSearch ? "展开" : "收起" }}</el-button
          >
        </div>
      </div> -->
      <!-- <el-collapse-transition> -->
      <el-form
        style="transition: all 500ms linear"
        :class="showSearch ? 'expand searchContent' : 'up searchContent'"
        ref="search-form"
        label-position="right"
        :model="searchForm"
      >
        <template v-for="(column, index) in option.column">
          <!-- style="white-space: nowrap" -->
          <el-form-item
            :prop="column.prop"
            :label="column.label"
            v-if="column.search"
            :key="index"
          >
            <template>
              <slot
                v-if="column.searchSlot"
                :name="'search_' + column.prop"
                :row="searchForm"
              ></slot>
              <el-select
                v-model="searchForm[column.prop]"
                v-else-if="column.type === 'select'"
                :multiple="column.multiple || false"
                :filterable="column.filterable || false"
                clearable
              >
                <el-option
                  v-for="item in column.dicData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-cascader
                v-model="searchForm[column.prop]"
                v-else-if="column.type === 'cascader'"
                clearable
                :show-all-levels="column.showAll || false"
                :options="column.dicData"
                :props="column.props"
              ></el-cascader>
              <!-- <el-radio v-else-if="column.type === 'radio'"
                        v-model="searchForm[column.prop]"
                        :label="item.label"
                        v-for="item in column.dicData"
                        :key="item.value">{{item.label}}</el-radio> -->
              <el-date-picker
                v-else-if="column.type === 'datetime'"
                v-model="searchForm[column.prop]"
                type="datetime"
              ></el-date-picker>
              <el-date-picker
                v-else-if="column.type === 'date'"
                type="date"
                :value-format="column.valueFormat || 'yyyy-MM-dd'"
                placeholder="选择日期"
                v-model="searchForm[column.prop]"
              ></el-date-picker>
              <el-date-picker
                v-else-if="column.type === 'daterange'"
                v-model="searchForm[column.prop]"
                type="daterange"
                range-separator="至"
                :value-format="column.valueFormat || 'yyyy-MM-dd'"
                start-placeholder="开始日期"
                :default-time="['00:00:00', '23:59:59']"
                end-placeholder="结束日期"
              ></el-date-picker>
              <el-date-picker
                v-else-if="column.type === 'datetimerange'"
                v-model="searchForm[column.prop]"
                clearable
                editable
                :value-format="column.valueFormat || 'yyyy-MM-dd HH:mm:ss'"
                type="datetimerange"
                range-separator="至"
                :start-placeholder="
                  column.startPlaceholder ? column.startPlaceholder : '开始日期'
                "
                :end-placeholder="
                  column.endPlaceholder ? column.endPlaceholder : '结束日期'
                "
              ></el-date-picker>
              <el-input
                v-else
                :placeholder="
                  column.searchPlaceholder ||
                  column.placeholder ||
                  `${$t('tip.input')}${column.label}`
                "
                v-model="searchForm[column.prop]"
                :type="column.type"
                :clearable="column.clearable ? column.clearable : false"
                :maxlength="column.maxlength"
                :autosize="{ minRows: column.minRows }"
              ></el-input>
            </template>
            <!-- <el-input :placeholder="column.searchPlaceholder"></el-input> -->
            <!-- <template slot-scope="scope">
              <slot :name="column.prop" :row="scope.row">
              </slot>
            </template>-->
          </el-form-item>
        </template>
        <!-- <el-form-item :style="searchBtnStyle">
          <el-button class="query-btn" type="primary" @click="query">{{
            $t("accountGroup.button.query")
          }}</el-button>
          <el-button type="info" @click="reset">{{
            $t("accountGroup.button.reset")
          }}</el-button>
        </el-form-item> -->
        <template>
          <slot name="export"></slot>
        </template>
      </el-form>
      <!-- </el-collapse-transition> -->
      <div>
        <el-button class="query-btn" type="primary" @click="query">{{
          $t("accountGroup.button.query")
        }}</el-button>
        <el-button type="info" @click="reset">{{
          $t("accountGroup.button.reset")
        }}</el-button>
        <el-button
          v-show="showExpandBtn"
          type="text"
          size="medium"
          style="color: #407aee; margin-left: 25px"
          @click="showSearch = !showSearch"
          :icon="showSearch ? 'el-icon-arrow-up ' : 'el-icon-arrow-down'"
          >{{ !showSearch ? "展开" : "收起" }}</el-button
        >
      </div>
    </div>
    <!-- 可配置按钮 -->
    <!-- <div class="ioc-content"> -->
    <div
      class="ioc-table__menu"
      v-if="$scopedSlots.menuLeft || $scopedSlots.menuRight"
    >
      <div class="menu-left">
        <slot name="menuLeft"></slot>
      </div>
      <div class="menu-right">
        <slot name="menuRight"></slot>
      </div>
    </div>

    <div
      v-else-if="$scopedSlots.menuSearch"
      class="ioc-table__search"
      style="margin-top: 16px"
    >
      <slot name="menuSearch"></slot>
    </div>
    <div class="ioc-table__content">
      <el-table
        :data="data"
        :stripe="option.stripe"
        size="mini"
        :border="option.border || false"
        :row-key="option.rowKey || 'id'"
        ref="multipleTable"
        :highlight-current-row="option.highlightCurrentRow || false"
        :show-header="option.showHeader"
        :row-style="option.rowStyle"
        :max-height="option.maxHeight || '100%'"
        @row-click="rowClick"
        @selection-change="selectionChange"
        @sort-change="(sort) => $emit('sort-change', sort)"
      >
        <el-table-column
          v-if="option.selection"
          type="selection"
          :reserve-selection="option.reserveSelection || false"
          align="center"
        />
        <el-table-column width="60" v-if="option.radio" label="选择">
          <template slot-scope="scope">
            <el-radio
              v-model="templateRadio"
              :label="scope.$index"
              @change.native="getTemplateRow(scope.$index, scope.row)"
              >{{ "" }}</el-radio
            >
          </template>
        </el-table-column>

        <el-table-column
          v-if="option.index"
          type="index"
          align="center"
          header-align="center"
          :label="option.indexLabel || $t('base.label.index')"
        />
        <template v-for="(column, index) in option.column">
          <el-table-column
            :prop="column.prop"
            :label="column.label"
            v-if="!column.hide"
            :width="column.columnWidth"
            :sortable="column.sortable"
            align="center"
            show-overflow-tooltip
            header-align="center"
            :key="index"
          >
            <template slot-scope="scope">
              <slot :name="column.prop" :row="scope.row">{{
                column.formatter
                  ? column.formatter(scope.row, scope.row[column.prop])
                  : scope.row[column.prop]
              }}</slot>
            </template>
          </el-table-column>
        </template>
        <el-table-column
          v-if="$scopedSlots.menu"
          :label="$t('crud.menu')"
          :width="option.menuWidth || 0"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <slot name="menu" :row="scope.row" :index="scope.$index"></slot>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="table-empty">
            <img src="@/common/assets/images/empty.svg" />
            <p>{{ $t("base.label.empty") }}</p>
          </div>
        </template>
      </el-table>
    </div>

    <div class="ioc-table__pagination" v-if="page.total">
      <el-pagination
        class="mt10 mb10"
        background
        :layout="page.layout || 'total, sizes, prev, pager, next, jumper'"
        :page-size="page.pageSize"
        :total="page.total"
        :pager-count="page.countPage || 7"
        :current-page="page.currentPage"
        @size-change="sizeChange"
        @current-change="pageChange"
        @prev-click="pageChange"
        @next-click="pageChange"
      />
    </div>
    <!-- </div> -->
    <appPanel
      class="app-panel dialog-form"
      :width="
        option.dialogWidth ? Number(option.dialogWidth.split('p')[0]) : 700
      "
      :isExpand="(dialogType === 'add' || dialogType === 'edit') && showDialog"
      @cancel="closeAdd"
      :title="option[dialogType]"
    >
      <!-- <div :style="{ height: option.dialogHeight + 'px', overflow: 'hidden' }"> -->
      <div style="overflow: auto">
        <el-scrollbar style="height: 100%" ref="scroll">
          <el-form
            ref="formPanel"
            :model="form"
            :label-suffix="option.labelSuffix || ''"
            :label-position="option.labelPosition || 'right'"
            :label-width="option.labelWidth || '100px'"
          >
            <el-row class="dialog-row">
              <template v-for="(col, index) in option.column">
                <!-- :span="col.span - 1 || 11" -->
                <el-col
                  :key="index"
                  v-if="isColumnDisplay(col)"
                  :span="col.span"
                >
                  <el-form-item
                    :prop="col.prop"
                    :label="col.label"
                    :rules="col.rules"
                  >
                    <template>
                      <slot
                        v-if="col.formslot"
                        :name="col.prop + 'Form'"
                        :row="form"
                      ></slot>
                      <el-select
                        v-model="form[col.prop]"
                        style="width: 100%"
                        :disabled="isColumnDisabled(col)"
                        v-else-if="col.type === 'select'"
                        :multiple="col.multiple || false"
                        :filterable="col.filterable"
                        :clearable="col.clearable ? col.clearable : true"
                        @change="selectChange(col)"
                      >
                        <el-option
                          v-for="item in col.dicData"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <el-date-picker
                        v-else-if="col.type === 'datetime'"
                        placeholder="选择日期"
                        type="datetime"
                        style="width: 100%"
                        :disabled="isColumnDisabled(col)"
                        v-model="form[col.prop]"
                        :picker-options="
                          col.pickerDisabled ? col.pickerDisabled : {}
                        "
                      ></el-date-picker>
                      <el-date-picker
                        v-else-if="col.type === 'date'"
                        placeholder="选择日期"
                        type="date"
                        style="width: 100%"
                        :disabled="isColumnDisabled(col)"
                        v-model="form[col.prop]"
                        :picker-options="
                          col.pickerDisabled ? col.pickerDisabled : {}
                        "
                      ></el-date-picker>
                      <el-input
                        v-else
                        :placeholder="
                          col.searchPlaceholder ||
                          col.placeholder ||
                          `${$t('tip.input')}${col.label}`
                        "
                        v-model="form[col.prop]"
                        :disabled="isColumnDisabled(col)"
                        :type="col.type"
                        :show-password="col.showPassword || false"
                        :maxlength="
                          col.type === 'textarea'
                            ? col.maxlength || 200
                            : col.maxlength
                        "
                        :show-word-limit="col.type === 'textarea'"
                        @change="inputChange(col)"
                      ></el-input>
                    </template>
                  </el-form-item>
                </el-col>
              </template>
            </el-row>
          </el-form>
          <slot
            v-if="dialogType === 'add' && option.addFormSlot"
            name="addFormSet"
          >
          </slot>
        </el-scrollbar>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" :loading="btnLoading" @click="closeDialog()">{{
          btnLoading ? "提交中" : $t("accountGroup.button.cancel")
        }}</el-button>
        <el-button type="primary" :loading="btnLoading" @click="saveForm()">{{
          btnLoading ? "提交中" : $t("accountGroup.button.save")
        }}</el-button>
      </div>
    </appPanel>
    <appPanel
      class="app-panel dialog-form"
      :width="getAppPanelWidth(option)"
      :isExpand="showDialog && dialogType === 'view'"
      @cancel="closeAdd"
      :title="option[dialogType]"
    >
      <div style="overflow: auto">
        <el-scrollbar style="height: 100%">
          <el-form
            ref="form"
            style="margin: 20px 40px 0"
            :model="form"
            :label-suffix="option.labelSuffix || ''"
            :label-position="option.labelPosition || 'right'"
            :label-width="option.labelWidth || '100px'"
          >
            <el-row>
              <template v-for="(col, index) in option.column">
                <el-col
                  :key="index"
                  v-if="isColumnDisplay(col)"
                  :span="col.viewSpan || col.span || 12"
                >
                  <el-form-item :prop="col.prop" :label="col.label" :rules="{}">
                    <template>
                      <slot
                        v-if="col.viewslot"
                        :name="col.prop + 'View'"
                        :row="form"
                      ></slot>
                      <!-- <slot v-else-if="col.formslot"
                            :name="col.prop + 'Form'"
                            :row="form"></slot> -->
                      <label v-if="!col.viewslot">{{
                        col.viewFormatter
                          ? col.viewFormatter(col, form[col.prop])
                          : form[col.prop]
                      }}</label>
                    </template>
                  </el-form-item>
                </el-col>
              </template>
            </el-row>
          </el-form>
          <slot
            v-if="dialogType === 'view' && option.viewFormSlot"
            name="viewFormSet"
            :row="form"
          >
          </slot>
        </el-scrollbar>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="closeDialog()">{{
          $t("base.button.close")
        }}</el-button>
      </div>
    </appPanel>
  </div>
</template>

<script>
import appPanel from "@src/components/business/app-panel/index.vue";
export default {
  name: "IocTable",
  model: {
    prop: "formData",
    event: "handleReturn",
  },
  components: {
    appPanel,
  },
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    option: {
      type: Object,
      default() {
        return {};
      },
    },
    page: {
      type: Object,
      default() {
        return {
          currentPage: 1,
          total: 0,
          pageSize: 10,
        };
      },
    },
    showBtnBlock: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      btnLoading: false,
      showExpandBtn: false,
      showSearch: false,
      showDialog: false,
      showView: false,
      dialogType: "add",
      form: {},
      searchForm: {},
      templateRadio: "",
    };
  },
  computed: {
    searchLength() {
      let isShow = false;
      this.option.column.some((col) => {
        isShow = col.search;
        return col.search;
      });
      return isShow;
    },
    searchBtnStyle() {
      if (this.showBtnBlock) {
        return "display: block";
      }
      return "";
    },
  },
  watch: {
    formData(newVal) {
      this.form = newVal;
    },
    form(newVal) {
      this.form = newVal;
      if (this.option.column && this.option.column.length) {
        this.option.column.forEach((item) => {
          if (item.value) {
            this.form[item.prop] = item.value;
          }
          if (item.formFormmatter && item.formatter) {
            this.form[item.prop] = item.formatter(item, newVal[item.prop]);
          }
        });
      }
      this.$emit("handleReturn", this.form);
    },
  },
  mounted() {
    this.animation();
  },
  beforeDestroy() {
    window.onresize = null;
  },
  methods: {
    animation() {
      let that = this;
      let domAry =
        document.querySelector(".searchContent") &&
        document.querySelector(".searchContent").children;
      if (!domAry) {
        return;
      }
      window.onresize = function () {
        that.animation();
      };
      if (domAry[domAry.length - 1].offsetTop != domAry[0].offsetTop) {
        this.showExpandBtn = true;
      } else {
        this.showExpandBtn = false;
      }
    },
    getAppPanelWidth(option) {
      if (option.viewDialogWidth) {
        return Number(option.viewDialogWidth.split("px")[0]);
      } else if (option.dialogWidth) {
        return Number(option.dialogWidth.split("px")[0]);
      } else {
        return 700;
      }
    },
    // table 单选
    getTemplateRow(index, value) {
      this.$emit("radio-change", value);
    },
    setForm(key, value) {
      this.$set(this.form, key, value);
    },
    selectClear() {
      this.$refs.multipleTable.clearSelection();
    },
    sizeChange(val) {
      this.$store.dispatch("setCurrentPagesize", val);
      this.$emit("size-change", val);
    },
    pageChange(val) {
      this.$emit("current-change", val);
    },
    openAdd() {
      this.$emit("open-add");
    },
    rowAdd(row = {}) {
      this.dialogType = "add";
      this.form = JSON.parse(JSON.stringify(row));
      this.$nextTick(() => {
        this.$refs["formPanel"].clearValidate();
      });
      this.showDialog = true;
    },
    rowView(row, index) {
      this.dialogType = "view";
      this.form = JSON.parse(JSON.stringify(row));
      this.showDialog = true;
    },
    rowEdit(row, index) {
      this.dialogType = "edit";
      this.form = JSON.parse(JSON.stringify(row));
      this.showDialog = true;
    },
    closeAdd() {
      this.resetForm();
      this.showDialog = false;
      this.$emit("close-callback");
    },
    query() {
      this.$log.debug("ioc-table:query===>", this.searchForm);
      this.$emit("search-change", this.searchForm);
    },
    reset() {
      this.searchForm = {};
      this.$refs["search-form"].resetFields();
      this.$log.debug("ioc-table:reset===>", this.searchForm);
      this.$emit("search-reset", this.searchForm);
    },
    saveForm() {
      // console.log(this.form);
      // console.log(this.$refs["form"]);
      this.$refs["formPanel"].validate((res) => {
        // console.log(res);
        if (res) {
          this.btnLoading = true;
          setTimeout(() => {
            this.btnLoading = false;
          }, 1000);
          if (this.dialogType === "add") {
            this.$emit(
              "row-save",
              Object.assign({}, this.form),
              this.closeDialog,
              () => {}
            );
          } else if (this.dialogType === "edit") {
            this.$emit(
              "row-update",
              Object.assign({}, this.form),
              this.closeDialog,
              () => {}
            );
          }
        }
      });
    },
    closeDialog() {
      console.log("取消弹窗");
      this.resetForm();
      this.hide();
      this.btnLoading = false;
      this.$emit("row-cancle");
      if (this.$refs["scroll"]) {
        this.$refs["scroll"].wrap.scrollTop = 0;
      }
    },
    isColumnDisplay(col) {
      return (
        (("undefined" === typeof col.addDisplay || col.addDisplay) &&
          this.dialogType === "add") ||
        (("undefined" === typeof col.editDisplay || col.editDisplay) &&
          this.dialogType === "edit") ||
        (("undefined" === typeof col.viewDisplay || col.viewDisplay) &&
          this.dialogType === "view")
      );
    },
    isColumnDisabled(col) {
      return (
        (col.addDisabled && this.dialogType === "add") ||
        (col.editDisabled && this.dialogType === "edit") ||
        (col.viewDisabled && this.dialogType === "view")
      );
    },
    selectionChange(data) {
      this.$emit("selection-change", data);
    },
    rowClick(row) {
      this.$emit("row-click", row);
    },
    selectChange(val) {
      this.$emit(val.prop + "-change", { ...this.form });
    },
    inputChange(val) {
      this.$emit(val.prop + "-change", { ...this.form });
    },
    hide() {
      this.showDialog = false;
    },
    resetForm() {
      this.$refs["formPanel"].resetFields();
    },
  },
};
</script>

<style scoped lang="scss">
.modal {
  width: 100% !important;
}
</style>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0px solid #ebeef5 !important;
}
.el-table {
  border: none !important;
}
.el-table__row > td {
  border: none !important;
}
.el-table--border {
  border: none !important;
}
.el-table--border::after,
.el-table--group::after {
  display: none !important;
}
.ioc-table {
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  height: 100%;
  // padding-top: 10px;
  overflow: hidden;
  el-table td.el-table__cell,
  .el-table th.el-table__cell.is-leaf {
    border-bottom: 0px solid #ebeef5 !important;
  }
  .app-side-panel {
    // transition: transform 550ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    // top: -10px !important;
    height: 100% !important;
  }
  &__content {
    // margin-top: 20px;
    @include set_theme_color(background-color, left-menu-bg-color);
    width: 100%;
    padding: 0 16px;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    .ioc-theme .el-table {
      border: none !important;
    }
    .el-table__row > td {
      border: none !important;
    }
    .el-table--border {
      border: none !important;
    }
    .el-table--border::after,
    .el-table--group::after {
      display: none !important;
    }
  }
  &__pagination {
    @include set_theme_color(background-color, left-menu-bg-color);
    text-align: center;
    //position: absolute;
    //bottom: 0px;
    width: 100%;
    // width: calc(100% - 32px);
    padding: 0px 0px 15px;
    //overflow: auto;
  }
  &__search {
    display: flex;
    justify-content: space-between;
    @include set_theme_color(background-color, left-menu-bg-color);
    padding: 10px 16px 3px;
    .el-form-item {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 8px !important;
      vertical-align: top;
    }
    .el-form-item__label {
      padding-right: 10px;
      // width: 66px;
    }
    .el-form-item__content {
      // width: 200px;
      display: inline-block;
      vertical-align: top;
    }
    .expand {
      width: calc(100% - 250px);
      height: auto;
    }
    .up {
      width: calc(100% - 250px);
      height: 41px;
      overflow: hidden;
    }
  }
  &__menu {
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    position: relative;
    padding: 10px 16px 0px 16px;
    margin-top: 16px;
    overflow: hidden;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    @include set_theme_color(background-color, left-menu-bg-color);
    // border-bottom: 1px solid #3e5574;
  }
  .menu-left,
  .menu-right {
    margin-bottom: 20px;
    .el-button {
      margin-top: 10px;
    }
  }
  // .el-table__body-wrapper {
  //   max-height: calc(100% - 40px);
  // }
  // .el-table__fixed-body-wrapper {
  //   max-height: calc(100% - 40px);
  // }
  .el-form {
    .el-col {
      position: relative;
    }
  }
  .dialog-form {
    position: absolute;
    width: calc(100% - 0px);
    height: 100%;
    .el-form-item {
      display: block;
      margin-right: 10px;
    }
    .dialog-row {
      justify-content: space-around;
      &::before {
        display: none;
      }
    }
    .el-form-item__content {
      word-wrap: break-word;
    }
  }

  // 定制修改element-ui组件样式
  .el-select {
    width: 100%;
  }

  .el-textarea__inner {
    height: 120px;
    resize: none;
  }
  .export-tips {
    margin-left: 5px;
    color: red;
    vertical-align: middle;
  }
}
</style>
